export default {
    API_BASE_URL: "https://fnbggstageapi.nanhanglim.com",
    PRODUCT_MEDIA_BASE_URL: "https://fnbggstageapi.nanhanglim.com/media",
};